import store from 'store'

const el = '[data-content=CalendarOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CalendarOverlayDOM)=>{
            const groupId = CalendarOverlayDOM.dataset.groupId
            const skip = parseInt(CalendarOverlayDOM.dataset.skip) ?? 0
            const take = parseInt(CalendarOverlayDOM.dataset.take) ?? 10
            const createEventUrl = CalendarOverlayDOM.dataset.createEventUrl
            const allowedToEdit = CalendarOverlayDOM.dataset.allowedToEdit === "true" ? true : false

            store.commit('main/set_page_overlay_content_data', { groupId, skip, take, createEventUrl, allowedToEdit })
        })
    }
}